export enum FilterType {
    RESULTS_PER_PAGE = "resultperpage"
}